<template>
  <div>
    <!-- TODO: Ladeindikator nur zeigen, wenn Laden noch nicht abgeschlossen -->
    <!-- <div id="loadingIndicator">LADEBILDSCHIRM</div> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>
